import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import classNames from 'classnames'
import { ConditionRow } from '../../../../../../../components/ConditionRow/ConditionRow'
import { Button } from '../../../../../../../components/Button/Button'
import { Tooltip } from '../../../../../../../components/Tooltip/Tooltip'
import { FilterExpression } from '../../../../../../../models/Account'
import styles from './FilterGroup.module.scss'

interface EnforcedFilterCardProps {
  conditions: FilterExpression[]
}

export const EnforcedFilterCard: React.FC<EnforcedFilterCardProps> = ({ conditions }) => {
  if (conditions.length === 0) {
    return null
  }

  return (
    <div className='border rounded mb-3'>
      <div className='d-flex flex-column justify-content-center align-items-start gap-4 p-3 rounded-top zocks-bg-color-gray-100'>
        <div className='d-flex align-items-center gap-2 w-100'>
          <Button type='button' disabled tabIndex={-1} aria-hidden className={classNames('p-1', styles.iconButton)}>
            <i className='bi bi-chevron-expand' />
          </Button>
          <span className='fw-bold flex-grow-1'>Enforced</span>
          <Tooltip placement='left' title='These conditions are enforced by your organization and always apply alongside your filters.'>
            <Button type='button' className={classNames('p-2', styles.iconButton)} disabled>
              <i className='bi bi-lock' />
            </Button>
          </Tooltip>
        </div>
      </div>

      <div className='p-3'>
        <Row className='mb-2'>
          <Col>
            <span className='fw-bold small text-uppercase'>Conditions</span>
          </Col>
        </Row>

        <div className='d-flex flex-column gap-2'>
          {conditions.map((condition) => (
            <ConditionRow
              isEnforced
              key={condition.field}
              selectedLeftValue={condition.field}
              selectedOperator={condition.operator}
              leftValueOptions={condition.field ? [{ id: condition.field, label: condition.field }] : []}
              operatorOptions={condition.operator ? [{ id: condition.operator, label: condition.operator }] : []}
              leftValuePlaceholder='Select field'
              operatorPlaceholder='Select operator'
              rightValueComponent={
                <Form.Control
                  type='text'
                  className='p-2 zocks-bg-color-gray-100 rounded'
                  placeholder='Add value'
                  value={condition.source.value || ''}
                  disabled
                />
              }
              onLeftValueChange={() => {}}
              onOperatorChange={() => {}}
              onRemove={() => {}}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
